/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

import { ManageAudiencesComponentArgs } from 'cio/components/segments/manage-audiences/details';

export default class Delete extends Component<ManageAudiencesComponentArgs> {}
